export class Paginable {
  offset: number = 0;
  limit: number = 15;
  sortBy: string = 'departureDate';
  sortOrder: string = 'ASC';
}
